import { Group } from "../../utils/logger";

import { get } from "lodash";
import {
  DOMAIN_ERROR_TITLE,
  DOMAIN_ERROR_MSG,
  SET_CPP_CONFIG,
  CONFIG_ERROR,
  CONFIG_ERROR_TITLE,
  CONFIG_ERROR_MSG,
} from "../constants";

import InternalApi from "../../utils/axios.InternalConfig";
import { toastr } from "react-redux-toastr";

// Types
import { AxiosError, AxiosResponse } from "axios";

const LoggerGroup = new Group("Config Actions", { disable: false });

// ================================================================================================
// Config Operations ==============================================================================
// ================================================================================================

/**
 * Get Iframe Domain
 *
 */
export const getIframeDomain = (userKey: string) => async (dispatch: any) => {
  LoggerGroup.emit(`[i] Getting iframe domain for client[${userKey}]`);

  const result = await InternalApi.get(`/config/domain/${userKey}`).catch((err: AxiosError) => {
    const error = get(err, "response.data.error") || err.message || "Unknown Error";

    LoggerGroup.emit({ warn: "getIframeDomain Error" }) // Custom error log
      .emit({ error }) // Log the Axios Error
      .end(); // Send to console immediately

    toastr.error(DOMAIN_ERROR_TITLE, DOMAIN_ERROR_MSG);
  });

  if (!result || (result && result.data && result.data.domain === "")) {
    toastr.error(DOMAIN_ERROR_TITLE, DOMAIN_ERROR_MSG);
  }

  return result;
};

/**
 * Get CPP Config
 */
export const getCPPConfig = () => (dispatch: any) => {
  LoggerGroup.emit("[i] Retrieving config for cpp");

  InternalApi.get(`/cpp/config`)
    .then(handleSuccess) // Handle Successful response
    .catch(handleError); // Handle Error response

  function handleSuccess(res: AxiosResponse) {
    LoggerGroup.emit("GET CPP CONFIG RESPONSE", { table: res.data }).end();
    dispatch({ type: SET_CPP_CONFIG, payload: res.data });
  }

  function handleError(err: AxiosError) {
    const error = get(err, "response.data.error") || err.message;
    dispatch({ type: CONFIG_ERROR, payload: error });

    LoggerGroup.emit({ warn: "getCPPConfig Error" }) // Custom error log
      .emit({ error: error }) // Log the Axios Error
      .end(); // Send to console immediately

    if (error.includes(405)) {
      toastr.error(CONFIG_ERROR_TITLE, CONFIG_ERROR_MSG);
    } else {
      toastr.error(error, err.message);
    }
  }
};
